import { jwtDecode } from 'jwt-decode';
import { DateTime } from 'luxon';

import type { AuthenticateResponse } from '@appTypes/auth';

const loginDataStorageKey = 'LOGIN_DATA';
const logoutFlagStorageKey = 'LOGGED_OUT';

function storeLoginData(loginData: Omit<AuthenticateResponse, 'ulvc'>) {
  localStorage.setItem(loginDataStorageKey, JSON.stringify(loginData));
}

function retrieveLoginData() {
  const localData = localStorage.getItem(loginDataStorageKey);
  if (!localData) return null;
  const data = JSON.parse(localData) as AuthenticateResponse;
  return data;
}

const removeLoginData = () => localStorage.removeItem(loginDataStorageKey);

const storeLogoutFlag = (flag: boolean) =>
  localStorage.setItem(logoutFlagStorageKey, JSON.stringify(flag));

const retrieveLogoutFlag = () =>
  JSON.parse(localStorage.getItem(logoutFlagStorageKey) || 'false');

/**
 * Verifies that token is valid and also not expired.
 */
export function isValidJWT(token?: string) {
  if (!token) return false;

  try {
    const jwt = jwtDecode(token);

    if (!jwt.exp || !jwt) return false;

    const expiration = DateTime.fromSeconds(jwt.exp);
    const now = DateTime.now();

    if (expiration < now) return false;

    return true;
  } catch {
    return false;
  }
}

export const addSessionExp = (
  loginData: Omit<AuthenticateResponse, 'ulvc'>,
) => {
  const { token } = loginData || {};
  const { exp } = jwtDecode(token);
  return {
    ...loginData,
    exp,
  };
};

export default {
  storeLoginData,
  retrieveLoginData,
  removeLoginData,
  storeLogoutFlag,
  retrieveLogoutFlag,
  addSessionExp,
};
